// TODO : 아래 컬러 => HEX에서 name 정해서 사용할 것. 예) 유효기간 지난 것: NO_VALID, 파일 없음: NO_FILE 등
import React from 'react';
import { DOC_STATUS_COLOR } from './documentStatusLegend';
import { useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import { alpha, styled } from '@mui/material/styles';
// TODO : 최신버전은 TreeView가 @mui/lab에서 @mui/x-tree-view로 이동했으나 기존 개발버전이 작동하지 않아 올드버전 사용
// -import { TreeView, TreeItem } from '@mui/lab';
// +import { TreeView, TreeItem } from '@mui/x-tree-view';
import MuiTreeItem, { treeItemClasses } from '@mui/lab/TreeItem';
import SvgIcon from '@mui/material/SvgIcon';
// import * as MuiTreeItem from '@mui/x-tree-view/TreeItem';
import Collapse from '@mui/material/Collapse';
import { useSpring, animated } from '@react-spring/web';
// import Checkbox from '@mui/joy/Checkbox';
import {
  Box,
  Card,
  CardMedia,
  Checkbox,
  Chip,
  FormControlLabel,
  Grid,
  Icon,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Menu,
  MenuItem,
  ListItemText,
  ListItemIcon,
} from '@mui/material';
import  {
  AddBox,
  Article,
  CorporateFare,
  ChromeReaderMode,
  Comment,
  FileCopy,
  FilePresent,
  FormatListBulleted,
  Grain,
  MoveDown,
  Visibility,
  Circle,
  Clear,
  Warning,
  Block,
  Close,
  DisabledByDefault,
  Download,
  Delete,
  Lock,
  TableChart,
  WebAsset,
  Info,
  VisibilityOff,
  InfoOutlined,
} from '@mui/icons-material';
import {
  grey,
  red,
  deepOrange,
} from '@mui/material/colors';
import {
  dateFormat,
  // SecurityUtils,
} from "../../utils";
import * as g04docuFileActions from "../../store/g04docuFile";
import * as g04docuGTestSubstituteActions from "../../store/g04docuGTestSubstitute";

const ITEM_HEIGHT = 48;

const typographyVariant = "subtitle1";
// const height = '38px';
let height;

function EndSquare(props) {
  return (
    // <SvgIcon
    //   fontSize="inherit" 
    //   style={{ width: 14, height: 14 }}
    //   {...props}
    // >
    //   {/* 문서 외곽선 - 접힌 모서리 반영 */}
    //   <path 
    //     d="M4 2h12 L22 8 L22 22 L4 22 L4 2" 
    //     fill="none"
    //     stroke="currentColor"
    //     strokeWidth="1.5"
    //   />
    //   {/* 문서 내부 선 */}
    //   <path 
    //     d="M6 10h14M6 14h14M6 18h14" 
    //     stroke="currentColor" 
    //     strokeWidth="1.2" 
    //     fill="none"
    //   />
    //   {/* 우측 상단 접힘 표시 삼각형 */}
    //   <path
    //     d="M16 2l6 6h-6z"
    //     fill="#7e7e7e"
    //   />
    // </SvgIcon>
    <></>
  );
}

function TransitionComponent(props) {
  const style = useSpring({
    from: {
      opacity: 0,
      transform: 'translate3d(20px,0,0)',
    },
    to: {
      opacity: props.in ? 1 : 0,
      transform: `translate3d(${props.in ? 0 : 20}px,0,0)`,
    },
  });

  return (
    <animated.div style={style}>
      <Collapse {...props} />
    </animated.div>
  );
}

const StyledTreeItem = styled((props) => (
  <MuiTreeItem {...props} TransitionComponent={TransitionComponent} />
))(({ theme }) => ({
  [`& .${treeItemClasses.label}`]: {
    height,
    width: '100%',
    overflow: 'hidden',
  },
  [`& .${treeItemClasses.iconContainer}`]: {
    '& .close': {
      opacity: /*0.3*/0, // 자식없는 노드 안보이도록 함
    },
    // 트리 확장/축소 버튼 색상을 그레이 톤으로 변경
    '& .MuiSvgIcon-root': {
      color: '#D0D0D0', // 더 흐린 그레이 톤 색상
    },
  },
  [`& .${treeItemClasses.group}`]: {
    marginLeft: 34, // 들여쓰기 간격을 2배로 늘림
    // paddingLeft: 0, // indentation 조정
    borderLeft: `1px dashed ${alpha(theme.palette.text.primary, /*0.4*/0)}`, // 확대점선 삭제
  },
  // 모든 계층의 트리 아이템에 분리선 추가
  [`& .${treeItemClasses.content}`]: {
    paddingRight: 0,
    '&::after': {
      content: '""',
      position: 'absolute',
      // left: '40px',  // 체크박스 이후로 시작
      left: 0,
      bottom: 0,
      right: 0,  // 오른쪽 끝까지
      borderBottom: `1px solid ${alpha(theme.palette.divider, 0.05)}`,
    },
    position: 'relative',
  },
}));

const NotOpened = () => (
  <Tooltip title={"비공개 거래선의 문서는 열람할 수 없습니다."} placement="left-start">
    <IconButton
      color="primary"
      aria-label="file"
      // edge="end"
      // disabled
      sx={{ color: "#BDBDBD"}}
    >
      <Lock/>
    </IconButton>
  </Tooltip>
);

const GProjectG04ContentTreeItem = ({
  crudMode,
  items,
  selected,
  onSelect,
  disableMultiParentSelection,
  handleClickViewEachDoc,
  handleClickInfoMateialApprovalSummary,
  handleClickViewSummary,
  handleClickAddSubstituteTestDoc,
  reGenerate,
  readOnly,
  onDocumentSelected,
  columnWidths,
}) => {
  // const securityOpenedGClientsAboutMe = useSelector((state) => state.security.securityOpenedGClientsAboutMe);
  const { pathname } = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  // console.log(handleClickViewEachDoc);
  const tree = React.useMemo(() => flattenTree({ items }), [items]);
  const marksUncheckedRef = React.useRef(
    createMarksUnchecked({ tree, items, selected }),
  );
  
  const activeParentRef = React.useRef('');

  const openFunctionMenu = Boolean(anchorEl);
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };

  // 문서 상태 판단 함수
  const getDocumentStatus = React.useCallback((data) => {
    const hasDoc = data.documentPath;
    const hasPerformanceDoc = data.performanceData?.performanceDocumentPath;
    
    // 색상 로직과 일치하도록 수정
    if (!hasDoc && hasPerformanceDoc) {
      return '성능확인서';
    }
    if (data?.substitute === 'Y' && (data?.validYN || data?.valid)) {
      return '대체성적서';
    }
    if (data?.validYN || data?.valid) {
      return '유효';
    }
    if (hasDoc && !data?.endDate) {
      return '미설정';
    }
    return '유효기간 지남';
  }, []);

  // 문서 상태별 색상 반환 함수
  const getDocumentStatusColor = React.useCallback((data) => {
    const hasDoc = data.documentPath;
    const hasPerformanceDoc = data.performanceData?.performanceDocumentPath;
    
    // 팝업메뉴의 색상 계산 로직과 일치하도록 수정
    if (!hasDoc && hasPerformanceDoc) {
      return DOC_STATUS_COLOR.performance;
    }
    if (data?.substitute === 'Y') {
      return (data?.validYN || data?.valid) ? DOC_STATUS_COLOR.substitute : DOC_STATUS_COLOR.expired;
    }
    if (data?.validYN || data?.valid) {
      return DOC_STATUS_COLOR.valid;
    }
    if (hasDoc && !data?.endDate) {
      return DOC_STATUS_COLOR.expired;
    }
    return DOC_STATUS_COLOR.expired;
  }, []);

  // 문서 선택 핸들러 추가
  const handleDocumentSelect = React.useCallback((documentData, documentType) => {
    if (onDocumentSelected) {
      const status = getDocumentStatus(documentData);
      const color = getDocumentStatusColor(documentData);
      
      onDocumentSelected({
        name: documentData.label || documentData.name,
        type: documentType,
        status: status,
        color: color,
        data: documentData
      });
    }
  }, [onDocumentSelected, getDocumentStatus, getDocumentStatusColor]);

  React.useEffect(() => {
    // marksUncheckedRef.current = createMarksUnchecked({ tree, items, selected });
    // console.log('marksUnchecked', marksUncheckedRef.current);
    // console.clear();
    // console.log(JSON.stringify(marksUncheckedRef.current, null, 2));
    // console.log('activeParent', activeParentRef.current);
  }, [items, selected, tree]);

  const handleChange = ({ event, parents = [] }) => {
    // 읽기전용 모드일 때 체크박스 변경 방지
    if (readOnly) {
      return;
    }

    const {
      target: { value, checked },
    } = event;
    let newSelect = selected.slice();
    console.log({ value, checked, parents })
    if (checked) {
      newSelect = [...parents, value].reverse().reduce(
        (prev, curr, index) => {
          const node = curr;
          let newSelectSoFar = prev;

          if (index === 0) {
            const childNodes = getTreeNodes({ tree, node });
            const childNodesLength = childNodes.length;

            if (childNodesLength > 0) {
              newSelectSoFar = [
                ...newSelectSoFar.filter(
                  (select) => !childNodes.includes(select),
                ),
              ];

              marksUncheckedRef.current = marksUncheckedRef.current.filter(
                (marksUnchecked) =>
                  ![...childNodes, node].includes(marksUnchecked),
              );
            }
          } else {
            // const childNodes = getTreeNodes({ tree, node, depth: 1 });
            const childNodes = getTreeNodes({ tree, node });
            const childNodesLength = childNodes.length;

            if (childNodesLength > 0) {
              const isEveryChildrenExist = childNodes.every((childNode) =>
                newSelectSoFar.includes(childNode),
              );

              if (isEveryChildrenExist) {
                newSelectSoFar = [
                  ...newSelectSoFar.filter(
                    (select) => !childNodes.includes(select),
                  ),
                  node,
                ];

                marksUncheckedRef.current = marksUncheckedRef.current.filter(
                  (marksUnchecked) =>
                    ![...childNodes, node].includes(marksUnchecked),
                );
              }
            }
          }

          marksUncheckedRef.current = marksUncheckedRef.current.filter(
            (marksUnchecked) => !newSelectSoFar.includes(marksUnchecked),
          );

          return newSelectSoFar;
        },
        [...newSelect, value],
      );
    } else if (!checked && !newSelect.includes(value)) {
      let toExclude = value;
      newSelect = parents
        .slice()
        .reverse()
        .reduce(
          (prev, curr, index) => {
            const node = curr;
            let newSelectSoFar = prev;
            let childNodes;

            marksUncheckedRef.current = [
              ...new Set([...marksUncheckedRef.current, toExclude]),
            ];

            if (index === 0) {
              childNodes = getTreeNodes({ tree, node, depth: 1 });
              console.log(
                toExclude,
                childNodes,
                childNodes.filter((childNode) => childNode !== toExclude),
              );
              newSelectSoFar = [
                ...newSelectSoFar,
                ...childNodes.filter((childNode) => childNode !== toExclude),
              ];
            } else {
              childNodes = getTreeNodes({ tree, node, depth: 1 }).filter(
                (childNode) => childNode !== toExclude,
              );
              console.log(
                toExclude,
                childNodes,
                childNodes.filter((childNode) => childNode !== toExclude),
              );
              newSelectSoFar = [
                ...newSelectSoFar.filter(
                  (select) => !childNodes.includes(select),
                ),
                ...childNodes.filter(
                  (childNode) => !marksUncheckedRef.current.includes(childNode),
                ),
              ];
            }

            toExclude = curr;

            return newSelectSoFar;
          },
          newSelect.filter((select) => !parents.includes(select)),
        );
    } else {
      [...parents, value]
        .slice()
        .reverse()
        .forEach((item) => {
          const node = item;
          const childNodes = getTreeNodes({ tree, node, depth: 1 });

          if (childNodes.length > 0) {
            marksUncheckedRef.current = [
              ...new Set([...marksUncheckedRef.current, ...childNodes]),
            ];
          } else {
            marksUncheckedRef.current = [
              ...new Set([...marksUncheckedRef.current, node]),
            ];
          }
        });
      newSelect = newSelect.filter((select) => select !== value);
    }

    if (disableMultiParentSelection) {
      if (checked) {
        activeParentRef.current = parents.length > 0 ? parents[0] : value;
      } else {
        const childNodes = getTreeNodes({
          tree,
          node: parents.length > 0 ? parents[0] : value,
        });

        if (!childNodes.some((childNode) => newSelect.includes(childNode))) {
          activeParentRef.current = '';
        }
      }
    }

    console.log(newSelect)
    onSelect(newSelect);
  };

  const renderTreeItem = ({ nodes, parents = [], level = 0 }) => {
    // console.log(handleClickViewEachDoc);
    return nodes.filter(node => {
      // '기타' 노드이고 자식이 없으면 필터링
      if (node.label === '기타' && (!node.children || node.children.length === 0)) {
        return false;
      }
      return true;
    }).map((node) => {
      // TODO : node에 필요정보가 다 있음
      // console.log(node)
      const { id: value, label, type, data, children } = node;
      const checked =
        selected.includes(value) ||
        parents.some((parent) => selected.includes(parent));
      let disabled = activeParentRef.current
        ? !parents.includes(activeParentRef.current)
        : false;

      if (activeParentRef.current === value) {
        disabled = false;
      }

      // disabled = true; // TODO : 임시
      // 문서 타입인지 확인
      const isDocType = type?.substring(0, 3) === 'DOC' || type === 'DOMESTIC_AUTH' || type === 'DIVISION1';
      // console.log(isDocType)
      // 문서 타입일 때만 EndSquare 아이콘 사용
      const treeItemProps = {
        ...(isDocType && {
          expandIcon: <EndSquare />,
          collapseIcon: <EndSquare />,
          endIcon: <EndSquare />  // endIcon도 추가
        })
      };

      if (children && children.length > 0) {
        const indeterminate = isIndeterminate({ tree, selected, node: value });
        const treeItemLabel = createTreeItemLabel({
          formControlLabelProps: { label },
          nodeData: { label, type, data },
          checkboxProps: {
            value,
            checked,
            indeterminate,
            disabled,
            onChange: (event) => {
              // 읽기전용
              if (crudMode === 'R') {
                return;
              }
              
              handleChange({ event, parents });
            },
          },
          handleClickViewEachDoc,
          handleClickInfoMateialApprovalSummary,
          handleClickViewSummary,
          handleClickAddSubstituteTestDoc,
          reGenerate,
          openFunctionMenu,
          handleClick,
          anchorEl,
          handleClose,
          handleDocumentSelect,
          level,
          pathname,
          columnWidths,
        });

        return (
          <StyledTreeItem
            key={value}
            nodeId={value}
            label={treeItemLabel}
            {...treeItemProps}
          >
            {renderTreeItem({
              nodes: children,
              parents: [...parents, value],
              level: level + 1,
            })}
          </StyledTreeItem>
        );
      }

      const treeItemLabel = createTreeItemLabel({
        formControlLabelProps: { label },
        nodeData: { label, type, data },
        checkboxProps: {
          value,
          checked,
          disabled,
          onChange: (event) => {
            // 읽기전용
            if (crudMode === 'R') {
              return;
            }

            handleChange({ event, parents });
          },
        },
        handleClickViewEachDoc,
        handleClickInfoMateialApprovalSummary,
        handleClickViewSummary,
        handleClickAddSubstituteTestDoc,
        reGenerate,
        openFunctionMenu,
        handleClick,
        anchorEl,
        handleClose,
        handleDocumentSelect,
        readOnly,
        level, // 리프 노드에도 현재 레벨 전달
        pathname,
        columnWidths,
      });

      return (
        <StyledTreeItem
          key={value}
          nodeId={value}
          label={treeItemLabel}
          {...treeItemProps}
        />
      );
    });
  };

  return renderTreeItem({ nodes: items });
};

export default GProjectG04ContentTreeItem;

function flattenTree({ items, parent = 'root', depth = 0 }) {
  return items.reduce((prev, curr) => {
    Object.assign(prev, { [parent]: [...(prev[parent] || []), curr.id] });

    if (curr.children && curr.children.length > 0) {
      return {
        ...prev,
        ...flattenTree({
          items: curr.children,
          depth: depth + 1,
          parent: curr.id,
        }),
      };
    }

    return prev;
  }, {});
}

function createMarksUnchecked({ tree, items, selected }) {
  return items.reduce((prev, { id: node }) => {
    return [...prev, node, ...getTreeNodes({ tree, node })];
  }, []);
}

// TODO : 다운로드할 때 원본을 그대로 내려줄 경우 거래선의 문서들이 무작위로 배포될 염려가 있으므로 원본대조필 및 프로젝트 관련 문구를 추가하고
// 그것을 내려준다. 단, 문서가 많이 적재되므로 그 처리를 고려할 것
const handleClickFileDownload = async (documentPath) => {
  const arr = documentPath.split("/");
  const fileName = arr[arr.length - 1];

  // 1. Download
  const res = await downloadG04docuFile(documentPath);
  const blob = await res.blob(); // res.blob는 promise를 리턴함???
  
  // 2. Create blob link to download
  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  // 3. Append to html page
  document.body.appendChild(link);
  // 4. Force download
  link.click();
  // 5. Clean up and remove the link
  link.parentNode.removeChild(link);
}

const downloadG04docuFile = (documentPath) => g04docuFileActions.downloadDirect(documentPath)
const removeSubstitutes = ({ id, gclientId, g04docuGTestSubstituteId, documentPath }) => g04docuGTestSubstituteActions.removeWithFileDirect({ id, gclientId, g04docuGTestSubstituteId, documentPath });

const handleClickRemoveSubstituteDoc = async (data, func) => {
  console.log(data)
  const { gclientId, g04docuGTestSubstituteId, documentPath } = data;
  await removeSubstitutes({ id: g04docuGTestSubstituteId, gclientId, g04docuGTestSubstituteId, documentPath })
  func && func();
}

function createTreeItemLabel({
  formControlLabelProps = {},
  nodeData = {},
  checkboxProps = {},
  handleClickViewEachDoc,
  handleClickInfoMateialApprovalSummary,
  handleClickViewSummary,
  handleClickAddSubstituteTestDoc,
  reGenerate,
  openFunctionMenu,
  handleClick,
  anchorEl,
  handleClose,
  handleDocumentSelect,
  readOnly,
  level = 0,  // 레벨 정보 추가
  pathname,
  columnWidths,
}) {
  // console.log(securityOpenedGClientsAboutMe);
  // console.log(formControlLabelProps);
  // console.log(handleClickViewEachDoc);
  const { label, type, data, substitute } = nodeData;
  // console.log(nodeData)
  // 참고로 공정에서 유리 스펙은 data.elements에 들어있음
  
  let clientName = "";
  let itemList = "";
  let nodeTitle; // 국내가공유리제품 사전 인증과 업체명 타이틀
  let glassName = ""; // glassName 변수 정의

  // 노드 타이틀 생성
  if (type === 'GSUPPLY_CONFIRM_SUMMARY') {
    nodeTitle = <Typography variant={typographyVariant}>{label}</Typography>;
  } else if (type === 'GSUPPLY_CONFIRM_DOC') {
    nodeTitle = <Typography variant={typographyVariant}>{label}</Typography>;
  } else if (type === 'DOMESTIC_AUTH') {
    const titles = label.split(":");
    if (titles.length > 1) {
      const no = titles[0];
      glassName = titles[1]; // glassName 변수에 값 할당
      const specification = titles[2];
      
      // const authYN = data.authYN ? data.authYN : "N/A";
      // // const authName = data.authName ? data.authName : "N/A";

      nodeTitle = (<Stack direction="row" display="flex" alignItems="center">
        <Tooltip title={"품번"} placement="left-start">
          <Typography variant={typographyVariant} sx={{ mr: 2, fontWeight: 'bold', color: '#888888' }}>{no}</Typography>
        </Tooltip>
        <Typography variant={typographyVariant} sx={{ mr: 2 }}>{specification}</Typography>
      </Stack>);
    }
  } else if (type === 'CLIENT') {
    const titles = label.split(":");
    if (titles.length > 1) {
      clientName = titles[0];
      itemList = titles[1].split(",");
      
      nodeTitle = (<>
        <Typography variant={typographyVariant} sx={{ mr: 3  }}>{clientName}</Typography>
        { itemList.length > 0 && (<Typography variant={typographyVariant} color="primary" sx={{ fontSize: '0.9rem' }}>{itemList.join(' / ')}</Typography>) }
      </>);
    } else {
      nodeTitle = <Typography variant={typographyVariant}>{label}</Typography>;
    }
  }
  
  let hasDoc = false;
  if (type?.substring(0, 3) === 'DOC') {
    hasDoc = type === 'DOCTEST' ? 
      // 성적서일 때. gclientId를 비교하는 이유는 가공성적서의 경우 로그인업체의 성적서가 없는 경우 대체성적서로 KCC글라스의 성적서를 documentPath에 기록하기 때문
      !!data.documentPath && data.gclientId === data.gclient.id :
      // 기타 문서(일반, 인증서, 기타)
      !!data.documentPath;
  }

  let hasPerformanceDoc = type === 'DOCTEST' && !!data.performanceData?.performanceDocumentPath;
  const expiryRequired = type === 'DOCTEST' || type === 'DOCCERTIFICATION';
  const expiryUnset = hasDoc && data?.validYN !== true && !data?.endDate;
  const markedUnset = expiryUnset && expiryRequired;
  
  const cell = (key, node) => (
    <Box
      sx={{
        width: columnWidths?.[key] || 0,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      {node}
    </Box>
  );

  return (
    <Stack
      direction="row"
      alignItems="stretch"
      sx={{
        borderColor: grey[200],
        width: '100%',
        minWidth: 0,
      }}
    >
      <Stack direction={"row"}>
        {/* 문서 포함 여부 체크박스 */}
        <Checkbox 
          size="small"
          color="default" 
          checkedIcon={<DisabledByDefault size="small" />} 
          {...checkboxProps}
          sx={{
            color: '#BDBDBD', // 옅은 회색
            '&.Mui-checked': {
              color: '#9E9E9E', // 체크된 상태도 옅은 회색
            },
            '& .MuiSvgIcon-root': {
              borderRadius: 0, // 테두리를 직선으로 변경
            },
            '& .MuiCheckbox-root': {
              borderRadius: 0, // 체크박스 자체의 테두리도 직선으로
            },
          }}
          onClick={(event) => { 
            event.stopPropagation();
            if (!readOnly) {
              checkboxProps.onChange(event);
            }
          }}
        />
        {/* 문서 유효 여부 표시등: start */}
        {(() => {
          // DOC 타입이 아닌 경우 표시등을 보여주지 않음
          if (type?.substring(0, 3) !== 'DOC') {
            return null;
          }

          // 인증서·성적서는 만료일이 필수다. 날짜가 없으면 미설정.
          if (markedUnset) {
            return (
              <Box display="flex" alignItems="center" sx={{ color: DOC_STATUS_COLOR.expired }}>
                <Tooltip title="미설정" placement="right-start">
                  <Circle sx={{ width: 14, height: 14 }} />
                </Tooltip>
              </Box>
            );
          }

          // 유효한 문서가 있는 경우 (문서가 있고 유효하거나, 문서는 없지만 성능확인서가 있는 경우)
          if ((hasDoc && (data.valid || data.validYN)) || (!hasDoc && hasPerformanceDoc)) {
            return (
              <Box display="flex" alignItems="center" sx={{
                color: !hasDoc && hasPerformanceDoc
                  ? DOC_STATUS_COLOR.performance
                  : (data.substitute === 'Y' ? DOC_STATUS_COLOR.substitute : DOC_STATUS_COLOR.valid)
              }}>
                <Tooltip title="유효" placement="right-start">
                  <Circle sx={{ width: 14, height: 14 }} />
                </Tooltip>
              </Box>
            );
          }

          // 문서가 있지만 유효기간이 지난 경우
          if (hasDoc && !(data.valid || data.validYN)) {
            return (
              <Box display="flex" alignItems="center" sx={{ color: '#DB4E2E' }}>
                <Tooltip title="유효기간 지남" placement="right-start">
                  <Circle sx={{ width: 14, height: 14 }} />
                </Tooltip>
              </Box>
            );
          }

          // 문서도 없고 성능확인서도 없는 경우
          if (!(hasDoc || hasPerformanceDoc)) {
            return (
              <Box display="flex" alignItems="center" sx={{ color: '#DBDBDB' }}>
                <Tooltip title="서류없음" placement="right-start">
                  <Circle sx={{ width: 14, height: 14 }} />
                </Tooltip>
              </Box>
            );
          }

          return null;
        })()}
        {/* 문서 유효 여부 표시등: end */}
      </Stack>
      <Box sx={{ flex: 1, minWidth: 0, ml: 1, overflow: 'hidden', display: 'flex', alignItems: 'center' }}>
        {/* 목차 노드 텍스트: start */}
          
          {
            (
              type === 'CLIENT' ||
              type === 'DOMESTIC_AUTH' ||
              type === 'GSUPPLY_CONFIRM_SUMMARY' ||
              type === 'GSUPPLY_CONFIRM_DOC'
            ) ? (
              <Box display="flex" alignItems="center" sx={{ height }}>{nodeTitle}</Box>
            ) : (
              <Box display="flex" alignItems="center" sx={{ height }}>
                <Typography 
                  variant={typographyVariant}
                  noWrap
                  sx={{ 
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    color: type?.substring(0, 3) === 'DOC' && data ? (
                      !(hasDoc || hasPerformanceDoc) ? 
                        '#9B9B9B' : // 서류 없음
                      markedUnset ?
                        DOC_STATUS_COLOR.expired :
                      !(data.validYN || data.valid) && hasDoc ? 
                        "#DB4E2E" : // 만료된 문서
                        'inherit' // 그 외의 경우 기본 색상
                    ) : 'inherit' // DOC 타입이 아닌 경우 기본 색상
                  }}
                >
                  {`${type === 'DOCCERTIFICATION' ? `${data?.gstandardNo ? `[${data?.gstandardNo}]` : ''} ${label}` : label}`}
                </Typography>
              </Box>
            )
          }
      </Box>
        {/* 목차 노드 텍스트: end */}
        {cell('info', (
          <>
            {type === 'DOMESTIC_AUTH' && glassName && (
              <Tooltip title={glassName} placement="top">
                <InfoOutlined fontSize="small" sx={{ color: '#9B9B9B' }} />
              </Tooltip>
            )}
            {type === 'DOCTEST' && data.selectedClassifications && data.selectedClassifications.filter(c => c.checked === true).length > 0 && (
              <Tooltip title={`종류·등급·호칭 또는 모델 : ${data.selectedClassifications?.filter(c => c.checked === true)[0]?.type}`} placement="top">
                <InfoOutlined fontSize="small" sx={{ color: '#9B9B9B' }} />
              </Tooltip>
            )}
          </>
        ))}
        {cell('view', (
          <>
            {type === 'GSUPPLY_CONFIRM_SUMMARY' && (
              <Tooltip title={"납품확인 요약정보 보기"} placement="right-start">
                <IconButton
                  aria-label="view"
                  onClick={handleClickViewSummary}
                  sx={{ color: "#2EA2DE" }}
                >
                  <TableChart />
                </IconButton>
              </Tooltip>
            )}
            {type === 'GSUPPLY_CONFIRM_DOC' && data.documentPath && (
              <Tooltip title={"납품확인서 보기"} placement="right-start">
                <IconButton
                  aria-label="view"
                  onClick={() => handleClickViewEachDoc(data.documentPath, data.gclientId)}
                  sx={{ color: "#2EA2DE" }}
                >
                  <Visibility />
                </IconButton>
              </Tooltip>
            )}
            {type === 'DOMESTIC_AUTH' && data?.authYN === 'Y' && data?.authDocumentPath && (
              <Tooltip title={"국내가공유리제품 사전 인증서 보기"} placement="right-start">
                <IconButton
                  aria-label="view"
                  // edge="end"
                  onClick={() => handleClickViewEachDoc(data.authDocumentPath, data.gclientId)}
                  sx={{ color: "#2EA2DE" }}
                >
                  <Visibility />
                </IconButton>
              </Tooltip>
            )}
            {/* 일반문서, 인증서, 성적서, 기타 문서 영역: start */}
            {(() => {
              // DOC 타입이 아닌 경우 아무것도 렌더링하지 않음
              if (type?.substring(0, 3) !== 'DOC' || !data) {
                return null;
              }

              // 문서가 있는 경우
              if (hasDoc || hasPerformanceDoc) {
                return (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ height }}
                  >
                    {data.gclient?.opened === false ? (
                      <NotOpened />
                    ) : data.substitute === 'Y' ? ( // 대체성적서인 경우
                      <>
                        {/* 기존 메뉴 방식 - 주석 처리 */}
                        {/* <Tooltip title={(<div>{"대체성적서입니다."}<br />{"상세메뉴를 보시려면 클릭해주세요."}</div>)} placement="left-start">
                          <IconButton
                            sx={{ color: data?.valid === false ? "#DB4E2E" : "#2EA2DE"}}
                            aria-label="more"
                            id="long-button"
                            aria-controls={openFunctionMenu ? 'long-menu' : undefined}
                            aria-expanded={openFunctionMenu ? 'true' : undefined}
                            aria-haspopup="true"
                            onClick={handleClick}
                          >
                            <MoveDown />
                          </IconButton>
                        </Tooltip>
                        <Menu
                          id="long-menu"
                          MenuListProps={{
                            'aria-labelledby': 'long-button',
                          }}
                          anchorEl={anchorEl}
                          open={openFunctionMenu}
                          onClose={handleClose}
                          PaperProps={{
                            style: {
                              maxHeight: ITEM_HEIGHT * 4.5,
                              width: '20ch',
                            },
                          }}
                        >
                          <MenuItem
                            key={"download"}
                            onClick={() => {
                              handleDocumentSelect(data, '대체성적서');
                              handleClickViewEachDoc(data.documentPath, data.gclient.id)
                              handleClose();
                            }}
                          >
                            <ListItemIcon><Visibility fontSize="small" /></ListItemIcon>
                            <ListItemText>{"보기"}</ListItemText>
                          </MenuItem>
                          <MenuItem
                            key={"remove"}
                            onClick={() => {
                              handleClickRemoveSubstituteDoc(data, reGenerate);
                              handleClose();
                            }}
                          >
                            <ListItemIcon><Delete fontSize="small" /></ListItemIcon>
                            <ListItemText>{"삭제"}</ListItemText>
                          </MenuItem>
                        </Menu> */}
                        
                        {/* 새로운 일반 성적서와 동일한 처리 방식 */}
                        <Tooltip title={"대체성적서 보기"} placement="left-start">
                          <IconButton
                            aria-label="view"
                            onClick={() => {
                              handleDocumentSelect(data, '대체성적서');
                              handleClickViewEachDoc(data.documentPath, data.gclient.id);
                            }}
                            sx={{ color: markedUnset ? DOC_STATUS_COLOR.expired : (data?.valid === false ? DOC_STATUS_COLOR.expired : DOC_STATUS_COLOR.substitute) }}
                          >
                            <Visibility />
                          </IconButton>
                        </Tooltip>
                        {type === 'DOCTEST' && (
                          data.gtestComparisonDocumentPath ? (
                            <Tooltip title={"시험성과대비표 보기"} placement="right-start">
                              <IconButton
                                aria-label="view"
                                onClick={() => {
                                  handleDocumentSelect(data, '시험성과대비표');
                                  handleClickViewEachDoc(data.gtestComparisonDocumentPath, data.gclient.id);
                                }}
                                sx={{ color: markedUnset ? DOC_STATUS_COLOR.expired : ((data?.validYN || data?.valid) ? "#2EA2DE" : "#DB4E2E") }}
                              >
                                <Visibility />
                              </IconButton>
                            </Tooltip>
                          ) : (
                            <Tooltip title={"시험성과대비표 없음"} placement="right-start">
                              <IconButton
                                aria-label="download"
                                sx={{ color: '#DBDBDB' }}
                              >
                                <VisibilityOff />
                              </IconButton>
                            </Tooltip>
                          )
                        )}
                      </>
                    ) : ( // data.substitute !== 'Y' => 대체성적서가 아닌 경우 (일반문서, 인증서, 기타 문서도 해당)
                      <>
                        <Tooltip title={`보기${!hasDoc && hasPerformanceDoc ? " (성능확인서) " : ""}`} placement="left-start">
                          <IconButton
                            aria-label="view"
                            onClick={() => {
                              const documentType = !hasDoc && hasPerformanceDoc ? '성능확인서' : 
                                type === 'DOCTEST' ? '성적서' : 
                                type === 'DOCCERTIFICATION' ? '인증서' : '일반문서';
                              
                              handleDocumentSelect(data, documentType);
                              handleClickViewEachDoc(hasDoc ? data.documentPath : (hasPerformanceDoc ? data.performanceData?.performanceDocumentPath : ""), data.gclient.id);
                            }}
                            sx={{ color: !hasDoc && hasPerformanceDoc ? DOC_STATUS_COLOR.performance : (markedUnset ? DOC_STATUS_COLOR.expired : ((data?.validYN || data?.valid) ? DOC_STATUS_COLOR.valid : DOC_STATUS_COLOR.expired)) }}
                          >
                            <Visibility />
                          </IconButton>
                        </Tooltip>
                        {type === 'DOCTEST' && (
                          hasDoc && data.gtestComparisonDocumentPath ? (
                            <Tooltip title={"시험성과대비표 보기"} placement="right-start">
                              <IconButton
                                aria-label="view"
                                onClick={() => {
                                  handleDocumentSelect(data, '시험성과대비표');
                                  handleClickViewEachDoc(data.gtestComparisonDocumentPath, data.gclient.id);
                                }}
                                sx={{ color: markedUnset ? DOC_STATUS_COLOR.expired : ((data?.validYN || data?.valid) ? "#2EA2DE" : "#DB4E2E") }}
                              >
                                <Visibility />
                              </IconButton>
                            </Tooltip>
                          ) : (
                            <Tooltip title={"시험성과대비표 없음"} placement="right-start">
                              <IconButton
                                aria-label="download"
                                sx={{ color: '#DBDBDB' }}
                              >
                                <VisibilityOff />
                              </IconButton>
                            </Tooltip>
                          )
                        )}
                      </>
                    )}
                  </Box>
                );
              }

              // 보안이 열려 있는 경우가 많을 것이기에 문서가 있는지 체크하는 부분을 먼저 체크하고 뒤에서 체크
              // 이것도 뒤에 나오는 서류없음 체크 전 비효율적이긴 하나 코드 중복으로 인해 여기서 체크함
              if (data.gclient?.opened === false) {
                return <Box display="flex" justifyContent="center" alignItems="center" sx={{ height }}><NotOpened /></Box>;
              }

              // 성적서 중 문서가 없는 경우
              // if (type === 'DOCTEST' && !(hasDoc || hasPerformanceDoc) && data.substitute !== 'N') {
              //   // 대체성적서를 추가할 수 있는 경우
              //   return (
              //     <Box display="flex" justifyContent="center" alignItems="center" sx={{ height }}>
              //       <Tooltip title={"대체성적서 추가"} placement="left-start">
              //         <IconButton
              //           aria-label="download"
              //           onClick={(e) => handleClickAddSubstituteTestDoc(e, data)}
              //           sx={{ color: '#ef5350' }}
              //         >
              //           <AddBox />
              //         </IconButton>
              //       </Tooltip>
              //     </Box>
              //   );
              // }
              
              // 문서가 없는 경우
              return (
                <Box display="flex" justifyContent="center" alignItems="center" sx={{ height }}>
                  <Tooltip title={"서류없음"} placement="left-start">
                    <IconButton
                      aria-label="download"
                      sx={{ color: '#DBDBDB' }}
                    >
                      <VisibilityOff />
                    </IconButton>
                  </Tooltip>
                </Box>
              );

              // // 문서가 없는 경우들
              // if (type !== 'DOCTEST') {
              //   // 성적서가 아닌 문서에서 문서가 없는 경우
              //   return (
              //     <Box display="flex" justifyContent="center" alignItems="center" sx={{ height }}>
              //       <Tooltip title={"서류없음"} placement="left-start">
              //         <IconButton
              //           aria-label="download"
              //           sx={{ color: '#DBDBDB' }}
              //         >
              //           <VisibilityOff />
              //         </IconButton>
              //       </Tooltip>
              //     </Box>
              //   );
              // }

              // // 성적서에서 문서가 없는 경우들
              // if (!data.documentPath && data.substitute === 'N') {
              //   // 일반 성적서인데 문서가 없는 경우
              //   return (
              //     <Box display="flex" justifyContent="center" alignItems="center" sx={{ height }}>
              //       <Tooltip title={"서류없음"} placement="left-start">
              //         <IconButton
              //           aria-label="download"
              //           sx={{ color: '#ef5350' }}
              //         >
              //           <VisibilityOff />
              //         </IconButton>
              //       </Tooltip>
              //     </Box>
              //   );
              // }

              // if (!data.documentPath && !data.performanceData?.performanceDocumentPath && data.substitute !== 'N') {
              //   // 대체성적서를 추가할 수 있는 경우
              //   return (
              //     <Box display="flex" justifyContent="center" alignItems="center" sx={{ height }}>
              //       <Tooltip title={"대체성적서 추가"} placement="left-start">
              //         <IconButton
              //           aria-label="download"
              //           onClick={(e) => handleClickAddSubstituteTestDoc(e, data)}
              //           sx={{ color: '#ef5350' }}
              //         >
              //           <AddBox />
              //         </IconButton>
              //       </Tooltip>
              //     </Box>
              //   );
              // }

              // return null;
            })()}
          </>
        ))}
        {cell('expiry', (
            data?.gclient?.opened === true && type?.substring(0, 3) === 'DOC' && data && (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{ height }}
              >
                {data.validYN ? (
                  <Typography 
                    sx={{ 
                      fontSize: '0.8125rem',
                      textAlign: 'center',
                      width: '112px',
                    }}
                  >
                    만료일 없음
                  </Typography>
                ) : data.endDate ? (
                  <Tooltip title={"만료일"}>
                    <Chip
                      label={` ~ ${dateFormat(data.endDate, 'yyyy-MM-dd')}`}
                      color={data?.valid === false ? "warning" : "primary"}
                      variant={data?.valid === false ? "" : "outlined"}
                      sx={{
                        width: '112px',
                        backgroundColor: data?.valid === false ? '#DB4E2E' : 'transparent',
                        color: data?.valid === false ? '#fff' : '#2EA2DE',
                        border: data?.valid === false ? 'none' : '1px solid #2EA2DE'
                      }}
                    />
                  </Tooltip>
                ) : (
                  <Typography
                    sx={{
                      fontSize: '0.8125rem',
                      textAlign: 'center',
                      width: '112px',
                      color: !(hasDoc || hasPerformanceDoc) ? '#9B9B9B' : (expiryRequired ? DOC_STATUS_COLOR.expired : 'text.secondary'),
                      fontWeight: (hasDoc || hasPerformanceDoc) && expiryRequired ? 600 : 400,
                    }}
                  >
                    미설정
                  </Typography>
                )}
              </Box>
            )
        ))}
        {cell('updated', (
            data?.gclient?.opened === true && (
              type?.substring(0, 3) === 'DOC' && data && data.mapUpdatedAt && (
                data.mapUpdatedAt ? (
                  <Box
                    display="flex" justifyContent="center" alignItems="center"
                    sx={{ height }}
                  >
                    <Tooltip title={"최종수정일시"}>
                      <Chip label={dateFormat(data.mapUpdatedAt)}></Chip>
                    </Tooltip>
                  </Box>
                ) : <></>
              )
            )
        ))}
    </Stack>
  );
}

function getTreeNodes({ tree, node = 'root', depth, currentDepth = 1 }) {
  const branches = tree[node];

  if (!branches) {
    return [];
  }

  return branches.reduce((prev, curr) => {
    let newPrev = [...prev, curr];

    if (tree[curr] && (typeof depth === 'undefined' || depth > currentDepth)) {
      newPrev = [
        ...newPrev,
        ...getTreeNodes({
          tree,
          node: curr,
          depth,
          currentDepth: currentDepth + 1,
        }),
      ];
    }

    return newPrev;
  }, []);
}

function isIndeterminate({ tree, node: value, selected }) {
  return getTreeNodes({ tree, node: value }).some((node) =>
    selected.includes(node),
  );
}
